/* istanbul ignore file */
import {
  populateApiParams,
  typeAheadDetails,
} from '@americanexpress/one-maps-base/lib/utils/MapUtils';
import getLocale from './getLocale';
import normalizePathname from './normalizePathname';
import getTypeAheadRequestOneData from './requestBody/getTypeAheadRequestOneData';
import getOffersRequestOneData from './requestBody/getOffersRequestOneData';
import getEnrollmentRequestOneData from './requestBody/getEnrollmentRequestOneData';
import getIndustryBonusRequestOnedata from './requestBody/getIndustryBonusRequestOneData';
import getMerchantRecosRequestOneData from './requestBody/getMerchantRecosRequestOneData';
import getImpressionRequestOneData from './requestBody/getImpressionRequestOneData';
import getFeedbackRequestOneData from './requestBody/getFeedbackRequestOneData';
import getCampaign from './merchantApi/getCampaign';
import getMerchantPublicRecosRequestOneData
  from './requestBody/getMerchantPublicRecosRequestOneData';

// eslint-disable-next-line complexity
const getMapsOneDataCallDetails = (functionName, reqID, args, getState, apiKey) => {
  const pathname = normalizePathname(args && args.pathname);
  const isOnline = pathname.includes('/en-us/maps/online');
  let isOffers = false;
  if (pathname.includes('/maps/offers')) {
    isOffers = true;
  }
  const locale = getLocale(getState());
  const getEnv = (state = getState()) => {
    const localeFilename = state.getIn(['config', 'localeFilename']);
    let env = 'E3';
    if (localeFilename === 'integration') {
      env = 'E1';
    } else if (localeFilename === 'qa') {
      env = 'E2';
    }
    return env;
  };
  let oneDataFunctionName = functionName;
  let requestBody = {};
  let callCondition = true;
  let includeCredentials = true;

  if (functionName.includes('ReadMerchantPersonalizationTypeahead')) {
    const typeResults = typeAheadDetails(getEnv(getState()));
    let mleListId = false;
    if (typeResults.listIds[args.locationDetails.country]) {
      mleListId = typeResults.listIds[args.locationDetails.country].default;
    }
    requestBody = getTypeAheadRequestOneData(args,
      isOnline,
      locale,
      mleListId,
      apiKey);
    callCondition = args.locationDetails.country || isOnline;
    includeCredentials = false;
  } else if (functionName.includes('ReadMerchantMapsTabOffers')) {
    requestBody = getOffersRequestOneData(args,
      locale,
      reqID,
      apiKey,
      false,
      args.merchantOffer);
    oneDataFunctionName = 'ReadMerchantMapOffers.v1';
    callCondition = apiKey && args.merchantOffer;
  } else if (functionName.includes('ReadMerchantMapOffers')) {
    requestBody = getOffersRequestOneData(args,
      locale,
      reqID,
      apiKey,
      false);
    callCondition = apiKey && isOffers && args && args.query.nw && args.query.se;
  } else if (functionName.includes('ReadMerchantMapEnrolledOffers')) {
    requestBody = getOffersRequestOneData(args,
      locale,
      reqID,
      apiKey,
      true);
    oneDataFunctionName = 'ReadMerchantMapOffers.v1';
    callCondition = apiKey && isOffers && args && args.query.nw && args.query.se;
  } else if (functionName.includes('CreateMerchantMapOffersEnrollment')) {
    requestBody = getEnrollmentRequestOneData(
      locale,
      reqID,
      args.offer.treatment_identifier,
      args.offer.treatment_source_identifier,
      apiKey);
    callCondition = true;
  } else if (functionName.includes('ReadMerchantMapIndustryBonusCategories')) {
    requestBody = getIndustryBonusRequestOnedata('us', reqID, apiKey);
    callCondition = apiKey && !isOffers && !isOnline && (pathname === '/en-us/maps');
  } else if (functionName.includes('ReadMerchantMapRecommendation')) {
    callCondition = apiKey && !isOffers;
    const requestParams = populateApiParams(getState, isOnline, apiKey, args.query);
    const campaign = getCampaign(isOnline ? 'US' : args.query.country, getEnv(getState()));
    requestBody = getMerchantRecosRequestOneData(
      locale, reqID, apiKey, args.query, args.pathname, requestParams, campaign, isOnline);
  } else if (functionName.includes('ReadMerchantPublicMapRecommendation')) {
    callCondition = !isOffers;
    const requestParams = populateApiParams(getState, isOnline, false, args.query);
    const campaign = getCampaign(isOnline ? 'US' : args.query.country, getEnv(getState()));
    requestBody = getMerchantPublicRecosRequestOneData(
      locale, reqID, args.query, args.pathname, requestParams, campaign, isOnline);
  } else if (functionName.includes('CreateMerchantMapLogImpression')) {
    requestBody = getImpressionRequestOneData(args.impressionRequest);
  } else if (functionName.includes('CreateMerchantEditSuggestion')) {
    requestBody = getFeedbackRequestOneData(args.requestObj, apiKey);
    callCondition = true;
  }

  return {
    requestBody,
    oneDataFunctionName,
    callCondition,
    includeCredentials,
  };
};

export default getMapsOneDataCallDetails;
